module.exports = {"id":"193887","name":"Hernán Pérez","rating":"79","photo":"./data/images/photos/3/193887.png","club":{"name":"Deport. Alavés","logo":"./data/images/clubs/Deport.Alaves.png"},"positions":["MD","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HernanPerez0.json
// module id = 1733
// module chunks = 0